/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ByAddressRequestBuilderRequestsMetadata, type ByAddressRequestBuilder } from './byAddress/index.js';
// @ts-ignore
import { ByNameRequestBuilderRequestsMetadata, type ByNameRequestBuilder } from './byName/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /companyregistrations
 */
export interface CompanyregistrationsRequestBuilder extends BaseRequestBuilder<CompanyregistrationsRequestBuilder> {
    /**
     * The byAddress property
     */
    get byAddress(): ByAddressRequestBuilder;
    /**
     * The byName property
     */
    get byName(): ByNameRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CompanyregistrationsRequestBuilderUriTemplate = "{+baseurl}/companyregistrations";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CompanyregistrationsRequestBuilderNavigationMetadata: Record<Exclude<keyof CompanyregistrationsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byAddress: {
        requestsMetadata: ByAddressRequestBuilderRequestsMetadata,
    },
    byName: {
        requestsMetadata: ByNameRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
